import { render, staticRenderFns } from "./password-new.vue?vue&type=template&id=0b8e2bec&scoped=true"
import script from "./password-new.vue?vue&type=script&lang=js"
export * from "./password-new.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b8e2bec",
  null
  
)

export default component.exports